import classNames from 'classnames/bind';
import styles from './ListSubscribeAdmin.module.scss';
import { Link, NavLink } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import GlobalStateContext from '~/GlobalStateContext ';
import API_URL from '~/config';

const cx = classNames.bind(styles);

function ListSubscribeAdmin() {
    const [listContact, setListContact] = useState([]);
    const { token, setToken } = useContext(GlobalStateContext);
    const baseToken = localStorage.getItem('access_token');
    const [loading, setLoading] = useState(false);
    const [isAccessible, setIsAccessible] = useState(true);


    const checkAccess = async (func) => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_URL}/admin/check-access`, { function: func }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setIsAccessible(response.data.message === 'Authorized');
        } catch (error) {
            console.error("Access check failed:", error);
            setIsAccessible(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        checkAccess('SubscribeList');
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        fetchListSubscribe();
    }, []);

    const fetchListSubscribe = () => {
        axios
            .get(`${API_URL}/admin/subscribe`, {
                headers: {
                    Authorization: `Bearer ${token || baseToken}`,
                },
            })
            .then((response) => {
                setListContact(response.data.data);
            })
            .catch((error) => {
                // Handle error
                console.error('Error fetching data:', error);
            });
    };

    const handleDelete = (id) => {
        const confirmDelete = window.confirm(`Do you want to delete the record with ID ${id}?`);
        if (!confirmDelete) {
            return;
        }

        axios
            .delete(`${API_URL}/admin/subscribe/${id}`, {
                headers: {
                    Authorization: `Bearer ${token || baseToken}`,
                },
            })
            .then((response) => {
                alert('Deleted successfully');
                // After successful deletion, call the GET API again to update the list
                fetchListSubscribe();
            })
            .catch((error) => {
                // Handle error
                console.error('Error deleting data:', error);
            });
    };

    const formatDateTime = (dateTimeString) => {
        const date = new Date(dateTimeString);

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    if (loading) {
        return <div className={cx('loading')}>Loading...</div>;
    }

    if (!isAccessible) {
        return <div className={cx('error')}> Unauthorized </div>;
    }

    return (
        <div>
            <table className={cx('styled-table')}>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Email</th>
                        <th>Created At</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {listContact?.map((item, index) => {
                        return (
                            <tr key={item.id}>
                                <th>{index + 1}</th>
                                <th>{item.email}</th>
                                <th>{formatDateTime(item.created_at)}</th>
                                <th style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <button
                                        className={cx('button', 'delete-button')}
                                        onClick={() => {
                                            handleDelete(item.id);
                                        }}
                                    >
                                        Delete
                                    </button>
                                </th>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default ListSubscribeAdmin;
